import React from 'react';
import cx from 'clsx';
import Title from '../Title/Title';
import type { ManualType } from '../../util/types';
import Anchor from '../Anchor/Anchor';
import Box from '../Box/Box';
import classes from './Manual.module.scss';

export interface ManualProps extends React.HTMLProps<HTMLDivElement> {
  className?: string;
  title?: string;
  titleAppendix?: string;
  manual?: ManualType;
  manuals?: ManualType[];
  previousUrl?: string;
  previousLabel?: string;
  withPrevious?: boolean;
}

export default function Manual({
  className,
  title,
  titleAppendix,
  manual,
  manuals,
  previousUrl,
  previousLabel,
  withPrevious = false,
  ...others
}: ManualProps) {
  return (
    <div className={cx(classes.manual, className)} {...others}>
      <Title order={3} className={classes.title}>
        {title}
        {titleAppendix && <span className={classes.titleAppendix}>{titleAppendix}</span>}
      </Title>
      {manual && manual.file && manual.title && (
        <div className={classes.manualItem}>
          <Anchor href={manual.file} target="_blank">
            <Box className={classes.box}>{manual.title}</Box>
          </Anchor>
        </div>
      )}
      {manuals &&
        manuals
          .filter((manual) => manual.title && manual.file)
          .map((item, index) => (
            <div className={classes.manualItem} key={index}>
              <Anchor href={item.file} target="_blank">
                <Box className={classes.box}>{item.title}</Box>
              </Anchor>
            </div>
          ))}
      {previousUrl && withPrevious && (
        <div className={classes.previousManualWrapper}>
          <Anchor href={previousUrl} className={classes.previousManual}>
            {previousLabel}
          </Anchor>
        </div>
      )}
    </div>
  );
}
